const formatters = new Map<string, Intl.NumberFormat>();

/**
 * Money as Colombians read it: `$ 1.500.000` for COP (no decimals), two decimals otherwise.
 *
 * @param {number} value -- The amount.
 * @param {string} currency -- ISO 4217 code, `COP` by default.
 * @returns The formatted amount.
 */
export const formatMoney = (value: number, currency = 'COP'): string => {
  let formatter = formatters.get(currency);
  if (!formatter) {
    formatter = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency,
      maximumFractionDigits: currency === 'COP' ? 0 : 2,
    });
    formatters.set(currency, formatter);
  }
  return formatter.format(value);
};

/**
 * Today as `YYYY-MM-DD` in the browser's timezone.
 *
 * @returns The date.
 */
export const today = (): string => {
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

/**
 * Offers a blob as a download in the browser.
 *
 * @param {Blob} blob -- The file.
 * @param {string} filename -- The download name.
 */
export const saveBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
